var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketingAssignedHowerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "custom-user2-duotone-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-user2-duotone"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect-user2-duotone",
    width: 24,
    height: 24,
    transform: "translate(689.749 44)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask-group-user2-duotone",
    transform: "translate(-689.749 -44)",
    clipPath: "url(#clip-path-user2-duotone)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-user2-duotone",
    transform: "translate(695 49.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-user2-duotone",
    transform: "translate(0 0)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-user2-bg-1",
    d: "M95.672,167.634H95.6l.038-.038Z",
    transform: "translate(-88.886 -154.136)",
    fill: "#12a7ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-user2-bg-2",
    d: "M35.244,35.784q0-.08,0-.161A2.625,2.625,0,0,0,32.624,33H28.874a2.625,2.625,0,0,0-2.625,2.625q0,.081,0,.161a6.749,6.749,0,1,1,8.989,0Zm-4.495-5.035A2.25,2.25,0,1,0,28.5,28.5,2.25,2.25,0,0,0,30.749,30.749Z",
    transform: "translate(-24 -24)",
    fill: "#12a7ef",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-user2-outline",
    d: "M35.248,35.78C35.248,34.565,34.37,33,33,33H28.5c-1.371,0-2.25,1.566-2.25,2.781M24,30.749A6.749,6.749,0,1,1,30.749,37.5,6.749,6.749,0,0,1,24,30.749Zm9-2.25a2.25,2.25,0,1,1-2.25-2.25A2.25,2.25,0,0,1,33,28.5Z",
    transform: "translate(-24 -24)",
    fill: "none",
    stroke: "#12a7ef",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketingAssignedHowerIcon);
export default __webpack_public_path__ + "static/media/ticketing-assigned-hower-icon.94440a96529ad6e80ad9caa71448ee43.svg";
export { ForwardRef as ReactComponent };